import { generatePath, NavLink } from 'react-router-dom';
import clsx from 'clsx';
import styles from './menu-app.module.scss';
import { MenuData, menuData } from './menu-data';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useGetLikeMe } from '@/hooks/use-get-like-me';
import { routesApp } from '@/constans/routes';
import { useActionCableCreate } from '@/hooks/use-action-cable';
import { jwtService } from '@/services/jwt.service';
import WebApp from '@twa-dev/sdk';
import { SocketPayload } from '@/types/socket-payload';
import { profilesApi } from '@/api';
import { useVibration } from '@/store/useVibration';
import { useAuth } from '@/store/useAuth';
import { useMatchFound } from '@/store/useMatchFound';
import { useLogProfileChannelRejection } from '@/hooks/use-log-profile-channel-rejection';

interface Props {
    className?: string;
}

interface IItemsCount {
    [key: string]: {
        count: number,
        type: 'counter' | 'dot'
    };
}

export const MenuApp: React.FC<Props> = ({ className }) => {
    const { data, error } = useGetLikeMe();
    const [itemsCount, setItemsCount] = useState<IItemsCount>({});
    const navigate = useNavigate();

    const { setProfile } = useAuth((state) => state);

    const CHANEL_NAME = 'ProfileChannel';
    let chanel: any;
    const isDev = process.env.NODE_ENV === 'development';
    const getPathFromWebSocketUrlIsDev = (url: string) => {
        if (isDev) {
            // const parsedUrl = new URL(url);
            // return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
            // TODO: url to env
            return 'http://localhost:8255/cable';
            // return 'http://localhost:3300/cable';
        }
        return url;
    };
    const cable = useActionCableCreate(
        getPathFromWebSocketUrlIsDev('/cable')
    );

    const updateChatsCounter = async () => {
        try {
            let data = await profilesApi.getUnreadChatsCount();
            if (data?.data) {
                setItemsCount(
                    (prev) => ({
                        ...prev,
                        messages: {
                            count: data.data.unread_chats_count,
                            type: 'counter'
                        }
                    })
                );
            }
        } catch (e) {
            console.error('Chats api error', e)
        }
    }

    const { logProfileChannelRejection } = useLogProfileChannelRejection()

    useEffect(() => {
        updateChatsCounter()

        chanel = cable.subscriptions.create(
            {
                channel: CHANEL_NAME,
                authentication: WebApp.initData.length ? WebApp.initData : jwtService.getAccessToken(),
            },
            {
                connected() {
                    console.log('conented');
                },
                received(payload: SocketPayload) {

                    switch (payload.type) {
                        case 'message_created':
                            setItemsCount(
                                (prev) => ({
                                    ...prev,
                                    messages: {
                                        count: payload.data.chats_unread_count,
                                        type: 'counter'
                                    }
                                })
                            );

                            break;
                        case 'chat_created':
                            setItemsCount(
                                (prev) => ({
                                    ...prev,
                                    messages: {
                                        count: payload.data.chats_unread_count,
                                        type: 'counter'
                                    }
                                })
                            );

                            break;
                        case 'chat_cleared':
                            updateChatsCounter()
                            break;
                        case 'moderation_status_changed':
                            setProfile({
                                ...payload.data.profile
                            })
                            break;
                    }
                },
                disconnected() {
                    console.log('WebSocket отключён. Пытаемся переподключиться...');
                },
                rejected() {
                    console.log('Сервер отклонил подписку!');
                    logProfileChannelRejection({ channel: CHANEL_NAME })
                },
            },
        );

        return () => {
            console.log('unsubscribe from ProfileChannel')
            cable.subscriptions.remove(chanel);
        };
    }, []);


    useEffect(() => {
        if (error) {
            const axiosError = error as any;
            if (axiosError.response?.status === 403 && axiosError.response?.data?.is_banned) {
                navigate(routesApp.banned);
            }
        }

        if (data)
            setItemsCount(
                (prev) => ({
                    ...prev,
                    liked: {
                        count: [
                            ...data.data.paid,
                            ...data.data.free
                        ].length,
                        type: 'counter'
                    },
                })
            );
    }, [data, error]);

    const { isVibrationEnabled } =
        useVibration(state => state);
    
    const handleMenuClick = (link: string) => {
        navigate(generatePath(link));
        if (isVibrationEnabled) {
            WebApp
                .HapticFeedback
                .impactOccurred('medium');
            // pass for not android
            navigator.vibrate?.(10)
        }
    };

    const isShowTabNotificationIcon = (item: MenuData) => {
        if (
            Object
                .keys(itemsCount)
                .includes(item.value)
        )
            return itemsCount[
                item.value
            ]
                .count > 0
        return false
    }

    const { isMatchFound } = useMatchFound(state => state)

    return (
        <nav id="app-layout-menu" className={clsx(className, styles.menu, isMatchFound && styles['menu--hidden'])}>
            <ul className={styles.list}>
                {menuData.map((item) => {
                    const IconComponent = item.icon;
                    return (
                        <li
                            key={item.title}
                            className={styles.item}
                            onClick={() => handleMenuClick(item.path)}>
                            <NavLink
                                to={item.path}
                                className={
                                    ({ isActive }) =>
                                        isActive ?
                                            styles.link + ' ' + styles.active
                                        :
                                            styles.link
                                }>
                                <IconComponent />
                                {isShowTabNotificationIcon(item) && (
                                    itemsCount[item.value].type === 'counter' ?
                                        <div className={styles.counter}>
                                            {
                                                itemsCount[item.value].count >= 100 ?
                                                    99
                                                :
                                                    itemsCount[item.value].count
                                            }
                                        </div>
                                    :
                                        <div className={styles.notificationDot} />
                                )}
                            </NavLink>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};
